export default class AnnouncementBanner {
  constructor(element) {
    this.element = element;
    this.key =
      this.element.dataset.announcementKey || "site_announcement_default";
    this.closeButton = this.element.querySelector(".js-announcement-close");
    this.init();
  }

  init() {
    if (!this.getCookie(this.key)) {
      this.show();
    }

    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => {
        this.setCookie(this.key, "1", 30);
        this.hide();
      });
    }
  }

  show() {
    this.element.classList.remove("hidden");
  }

  hide() {
    this.element.classList.add("hidden");
  }

  getCookie(name) {
    const match = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/[.$?*|{}()\[\]\\\/+^]/g, "\\$&") +
          "=([^;]*)",
      ),
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  setCookie(name, value, days = 365) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
  }
}
